import styled from 'styled-components';

/*
 * Nothing on the web reports whether a physical keyboard is attached, so this
 * goes on the closest proxy: a coarse primary pointer that cannot hover is a
 * phone or a tablet, where telling someone to press escape is just noise. A
 * tablet with a keyboard case loses the hint, which is the harmless way round.
 */
export const KeyboardHint = styled.p`
  font-size: 12px;
  font-weight: 300;
  margin: 16px 0 0 0;
  text-align: center;

  @media (pointer: coarse) and (hover: none) {
    display: none;
  }
`;
